import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import unlockTherapistService from 'src/services/apiServices/unlockTherapist/unlockTherapistService';
import { unlockTherapistConstant } from '../../actions/constant';

const {
  GET_UNLOCK_THERAPIST_REQUEST,
  GET_UNLOCK_THERAPIST_SUCCESS,
  GET_UNLOCK_THERAPIST_FAILURE,
  GET_UNLOCK_THERAPIST_RESET,
  GET_UNLOCK_THERAPIST_LOADING,
} = unlockTherapistConstant;

function* getUnlockTherapist(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_UNLOCK_THERAPIST_LOADING });

    const response = yield call(unlockTherapistService.getUnlockTherapist, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_UNLOCK_THERAPIST_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_UNLOCK_THERAPIST_FAILURE, payload: error });
  }
}

function* getUnlockTherapistSaga() {
  yield takeEvery(GET_UNLOCK_THERAPIST_REQUEST, getUnlockTherapist);
}

export default getUnlockTherapistSaga;
